var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-wrapper",
    {
      attrs: {
        deletable: false,
        title: _vm.$ct("title-task-edit"),
        "max-width": _vm.maxWidth,
      },
      on: {
        save: function ($event) {
          return _vm.save()
        },
        cancel: function ($event) {
          return _vm.cancel()
        },
        delete: function ($event) {
          return _vm.remove()
        },
      },
    },
    [
      _c("app-task-edit", {
        attrs: { folders: _vm.folders },
        model: {
          value: _vm.task,
          callback: function ($$v) {
            _vm.task = $$v
          },
          expression: "task",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }